const STATUS_COLUMN = {
  columnName: 'status',
  active: 'active',
  inactive: 'inactive',
};

Object.freeze(STATUS_COLUMN);

export { STATUS_COLUMN };
